// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__mfaS8","button":"Home_button__nG-AV","pText":"Home_pText__qaKcq"};